// @flow
import { toCamelCase } from '../lib/string';
import { arrayContainsSameItem } from '../lib/array';

const normalizeEvent = (event: string | Object, type: string): Array<string> => {
  if (typeof event === 'object') {
    // eslint-disable-next-line
    return normalizeObjectEvent(event);
  }

  event = event.replace(/ /g, '');
  const events = event.split(',');
  let typedEvents;
  if (type) {
    typedEvents = [];
    events.forEach((event) => {
      typedEvents.push(toCamelCase(`${event}-${type}`));
    });
  }
  return typedEvents || events;
};

const normalizeObjectEvent = (event: Object): Array<string> => {
  const events = event.event;
  return normalizeEvent(events, event.type);
};

export const getNormalizedRefreshEvents = (refreshEvents) => {
  let normalizedRefreshEvents = [];

  if (refreshEvents) {
    if (Array.isArray(refreshEvents)) {
      refreshEvents.forEach((refreshEvent) => {
        normalizedRefreshEvents = normalizedRefreshEvents.concat(normalizeEvent(refreshEvent));
      });
    } else {
      normalizedRefreshEvents = normalizeEvent(refreshEvents);
    }
  }
  return normalizedRefreshEvents.map((event) => event.toLowerCase());
};

const separateAttrsFromObject = (event, separatedAttrs) => {
  const events = event.event;
  const eventsArray = normalizeEvent(events, event.type);
  const attrs = event.validAttributes;

  if (attrs) {
    eventsArray.forEach((event) => {
      separatedAttrs[event] = attrs;
    });
  }
  return separatedAttrs;
};

export const getRefreshEventsValidAttrs = (eventName, refreshEvents) => {
  let separatedAttrs = {};
  if (refreshEvents) {
    if (Array.isArray(refreshEvents)) {
      refreshEvents.forEach((refreshEvent) => {
        if (typeof refreshEvent === 'object') {
          separatedAttrs = separateAttrsFromObject(refreshEvent, separatedAttrs);
        }
      });
    } else if (typeof refreshEvents === 'object') {
      separatedAttrs = separateAttrsFromObject(refreshEvents, separatedAttrs);
    }
  }

  return separatedAttrs[eventName] || null;
};

export const isValidForRefresh = (event, refreshEvents, valueForComparing) => {
  const validAttrs = getRefreshEventsValidAttrs(event.type, refreshEvents);
  const eventAttrs = event.attr;
  if (validAttrs && event.attr) {
    let isValid = 1;
    Object.keys(validAttrs).forEach((key) => {
      const eventAttr = eventAttrs[key];
      let value = validAttrs[key];
      value = value === '@value' ? valueForComparing : value;

      if (Array.isArray(value)) {
        value = value.map((item) => item.toString());
        if (Array.isArray(eventAttr)) {
          // eslint-disable-next-line
          isValid &= arrayContainsSameItem(eventAttr, value);
        } else {
          // eslint-disable-next-line
          isValid &= value.includes(eventAttr);
        }
      } else {
        value = value.toString();
        if (Array.isArray(eventAttr)) {
          // eslint-disable-next-line
          isValid &= (eventAttr.includes(value));
        } else {
          // eslint-disable-next-line
          isValid &= (value == eventAttr);
        }
      }
    });
    return !!isValid;
  }
  return true;
};




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/webComponents/inlineHOCUtils.js